import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  title: Yup.string().required('You must give your message a title.'),
  body: Yup.string().required('You must write a message.'),
});

/* Constants */
export const CONFLICT_ERROR =
  'A message with the same title or body already exists.';
export const SUCCESS_MESSAGE = 'Message created successfully';
export const UPDATE_SUCCESS_MESSAGE = 'Message updated successfully';
export const DELETE_SUCCESS_MESSAGE = 'Message deleted successfully';
export const EDIT_HEADER = 'Edit Preconfigured Message';
export const CREATE_HEADER = 'Create New Preconfigured Message';
